import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

const StatsCard = ({
  icon,
  title,
  subtitle,
  value,
  secondaryValue,
  color,
  borderColor,
}) => (
  <Card
    className="mb-4"
    style={{
      borderTop: `1px solid ${color}`,
      borderRight: `1px solid ${color}`,
      borderBottom: `1px solid ${color}`,
      borderLeft: `4px solid ${color}`,
      borderRadius: "10px",
      height: "100px",
    }}
  >
    <CardBody className="d-flex align-items-center">
      <div
        className="d-flex align-items-center justify-content-center me-3"
        style={{
          minWidth: "50px",
          height: "50px",
          backgroundColor: `${color}15`,
          color: color,
          borderRadius: "14px",
        }}
      >
        <i
          className={icon}
          style={{ fontSize: "28px", color: color, fontWeight: "500" }}
        ></i>
      </div>
      <div className="flex-grow-1">
        <div
          className="mb-1"
          style={{ color: "#6A7282", fontSize: "12px", fontWeight: "400" }}
        >
          {title}
        </div>
        <div className="d-flex align-items-baseline">
          <h3
            className="mb-0 me-2"
            style={{ color: "#0A0A0A", fontSize: "24px", fontWeight: "400" }}
          >
            {value}
          </h3>
          {secondaryValue && (
            <span
              style={{ color: "#99A1AF", fontSize: "16px", fontWeight: "400" }}
            >
              / {secondaryValue}
            </span>
          )}
        </div>
        {subtitle && <div className="text-muted small">{subtitle}</div>}
      </div>
    </CardBody>
  </Card>
);

const MetricCards = ({ hasReservation }) => {
  const customerData = useSelector(
    (state) => state.GetMvnoDashboard.getMvnoDashboard
  );
  const stats = [
    {
      icon: "ri-flashlight-line",
      title: "Active vs Total Stations",
      //   subtitle: 'Total Stations',
      value: customerData?.[0]?.activeStationCount || "0",
      secondaryValue: customerData?.[0]?.totalStationCount || "0",
      color: "#2B7FFF",
      borderColor: "#2B7FFF",
    },
    {
      icon: "bx bx-group",
      title: "New Customers",
      value: customerData?.[0]?.activeCustomers?.totalCustomers || "0",
      color: "#00C950",
      borderColor: "#00C950",
    },
    {
      icon: "bx bx-user-x",
      title: "Churned Customers",
      //   subtitle: 'Customers',
      value: customerData?.[0]?.inactiveCustomers?.totalCustomers || "0",
      color: "#FB2C36",
      borderColor: "#FB2C36",
    },
    {
      icon: "ri-pulse-line",
      title: "Current Sessions",
      //   subtitle: 'Sessions',
      value: customerData?.[0]?.activeSessionCount || "0",
      color: "#FF6900",
      borderColor: "#FF6900",
    },
    hasReservation
      ? {
          icon: "ri-calendar-line",
          title: "Upcoming Reservations",
          //   subtitle: 'Reservations',
          value: customerData?.[0]?.upcomingReservationCount || "0",
          color: "#AD46FF",
          borderColor: "#AD46FF",
        }
      : null,
  ]?.filter(Boolean);

  return (
    <Container fluid className="pt-4">
      <Row className="gx-3">
        {stats.map((stat, index) => (
          <Col key={index} xs={12} sm={6} lg={4} xl>
            <StatsCard {...stat} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default MetricCards;
